<ng-container *ngIf="vm$ | async as vm">

    <ng-container *ngIf="vm?.calendarOptions && showCalendar">

        <div class="calendar-toolbar">
            <div class="timezone" *ngIf="vm?.timezone">
                <div class="timezone-label">Timezone</div>
                <div class="timezone-value">{{vm?.timezone}}</div>
            </div>

            <ng-container *ngIf="calendar?.getApi() as calendarApi">
                <appointments-date-range-picker [timezone]="$safeNavigationMigration(vm?.timezone)" [startDate]="$safeNavigationMigration(calendarApi?.view?.currentStart)" [endDate]="$safeNavigationMigration(calendarApi?.view?.currentEnd)" (goToDate)="calendarApi?.gotoDate($event)" (goToToday)="calendarApi?.today()" (moveNext)="calendarApi?.next()" (movePrev)="calendarApi?.prev()" />
            </ng-container>
        </div>

        <div class="calendar-content">
            <full-calendar #calendar [options]="$safeNavigationMigration(vm?.calendarOptions)" contentHeight="auto">

                <ng-template #eventContent let-args>
                    <event-card [event]="$safeNavigationMigration(args?.event)" [timezone]="$safeNavigationMigration(vm?.timezone)"></event-card>
                </ng-template>

                <ng-template #resourceLabelContent let-args>
                    <resource [resource]="$safeNavigationMigration(args?.resource?.extendedProps?.entity)"></resource>
                </ng-template>

                <ng-template #resourceAreaHeaderContent let-args>
                    <div class="modern-form filter-area">
                        <div class="fieldset">
                            <div class="field">
                                <div class="value">
                                    <appointment-resource-picker appendTo="body" [fetch]="PickerFetch.Manual" [multiple]="true" placeholder="<Filter Resources>" [data]="vm.resources" [formControl]="resourceFilterControl"></appointment-resource-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

            </full-calendar>
        </div>

    </ng-container>

</ng-container>